"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TimeSortingTypes = exports.sortArrayChronologically = void 0;

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/sort"));

var _moment = _interopRequireDefault(require("moment"));

/**
 * Sorts an array of objects by a time field, given a key of the object that is a properly formatted datetime string.
 */
var sortArrayChronologically = function sortArrayChronologically(arr, key) {
  var _context;

  var sortType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TimeSortingTypes.Descending;
  var undefinedToBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (arr.length <= 0) {
    return arr;
  }

  return (0, _sort.default)(_context = (0, _slice.default)(arr).call(arr, 0)).call(_context, function (a, b) {
    if (!a[key] || !b[key]) {
      if (undefinedToBottom) {
        return 1;
      } else {
        return -1;
      }
    }

    var sortingKeyA = (0, _moment.default)(a[key]);
    var sortingKeyB = (0, _moment.default)(b[key]);

    if (!sortingKeyA.isValid() || !sortingKeyB.isValid()) {
      return 0;
    }

    if (sortType === TimeSortingTypes.Descending) {
      return sortingKeyB.utc().diff(sortingKeyA.utc());
    } else {
      return sortingKeyA.utc().diff(sortingKeyB.utc());
    }
  });
};

exports.sortArrayChronologically = sortArrayChronologically;
var TimeSortingTypes;
exports.TimeSortingTypes = TimeSortingTypes;

(function (TimeSortingTypes) {
  TimeSortingTypes["Ascending"] = "ASC";
  TimeSortingTypes["Descending"] = "DESC";
})(TimeSortingTypes || (exports.TimeSortingTypes = TimeSortingTypes = {}));